module.exports = __webpack_public_path__ + "img/PCB_KayPad_Back.00d6a590.jpg";